module.exports = __webpack_public_path__ + "static/media/One-Click-Optimization.0350f3e6.png";